import template from './amend.html';
import controller from './amend.controller';

let amendComponent = {
    restrict: 'E',
    require: {
        booking: '^booking'
    },
    bindings: {
        amend: '<'
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default amendComponent;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/amend/amend.component.js